import useWebChatUIContext from '/druid/useWebChatUIContext';

export default function useSettableDictateAbortable() {
  const { dictateAbortable, setDictateAbortable } = useWebChatUIContext();

  return [dictateAbortable, setDictateAbortable];
}
